export const mockPos = {
  categories: [
    { id: "cat-electronic", name: "electronic", image: "shoe.jpg", status: "active" },
    { id: "cat-mobile",     name: "Mobile",     image: "shoe.jpg", status: "active" },
    { id: "cat-shoe",       name: "shoe",       image: "shoe.jpg", status: "active" },
    { id: "cat-juice",      name: "Juice",      image: "shoe.jpg", status: "active" },
    { id: "cat-shirt",      name: "Shirt",      image: "shoe.jpg", status: "active" },
    { id: "cat-deets",      name: "deets",      image: "shoe.jpg", status: "active" },
  ],
  products: [
    {
      id: "p-001",
      SKU: "SKU-446668",
      Product_Name: "p2excel 1234",
      Category: "Mobile",
      Brand: "Brand 1",
      Price: "100.00",
      Unit: "pr",
      Qty: 6,
      Created_By: "Demo",
      image: "shoes.jpg",
      tax: "0",
      discountValue: 0,
      discountType: "",
      taxType: "",
      variantItems: [],
      variantAttributes: []
    },
    {
      id: "p-002",
      SKU: "SKU-223344",
      Product_Name: "p2excel",
      Category: "Mobile",
      Brand: "Brand 1",
      Price: "100.00",
      Unit: "pr",
      Qty: 12,
      Created_By: "Demo",
      image: "shoes.jpg",
      tax: "0",
      discountValue: 0,
      discountType: "",
      taxType: "",
      variantItems: [],
      variantAttributes: []
    },
    {
      id: "p-003",
      SKU: "SKU-999111",
      Product_Name: "Dark Chocolate Bar",
      Category: "electronic",
      Brand: "Brand 2",
      Price: "3.50",
      Unit: "pcs",
      Qty: 50,
      Created_By: "Demo",
      image: "shoes.jpg",
      tax: "0",
      discountValue: 0,
      discountType: "",
      taxType: "",
      variantItems: [],
      variantAttributes: []
    },
    {
      id: "p-004",
      SKU: "SKU-555111",
      Product_Name: "Running Shoes",
      Category: "shoe",
      Brand: "Brand 3",
      Price: "42.00",
      Unit: "pair",
      Qty: 10,
      Created_By: "Demo",
      image: "shoes.jpg",
      tax: "0",
      discountValue: 0,
      discountType: "",
      taxType: "",
      variantItems: [],
      variantAttributes: []
    }
  ]
};